export const api = {
  salesListing: '/sales-list',
  downlineValidation: '/member-tree-downline-verify',
  classicCheck: '/classic-member-verify',
  salesProductSearch: '/sales/search-product-kitting',
  taxInvoiceSearch: '/invoice-list',
  taxInvoiceDetail: '/invoice-details',
  salesCancellationInvoiceDetailSearch: '/sales/sale-cancellation-invoice-details',
  salesCancellationCreation: '/sales/sale-cancellation-create',
  salesCancellationListingSearch: '/sales/sale-cancellation-list',
  salesCancellationDetail: '/sales/sale-cancellation-details',
  retrieveTaxInvoicePDF: '/invoice/downloadpdf',
  retrieveCreditNotePDF: '/sales/creditnote/downloadpdf',
  salesProductEligible: '/sales/sales-product-eligible',
  salesProductEligible_E: '/sales/sales-product-eligible-e',
  cancelECommerceReceipt: '/sales/cancelECommerce',
  sales: '/sales',
  salesDetails: '/sales-details',
  paymentModes: '/payments/sales',
  makePayment: '/payments/payment-make',
  productExchangeListingSearch: '/sales-exchange-list',
  productExchangeCreation: '/sales-exchange',
  productExchangeDetail: '/sales-exchange-details',
  cancellationBatchProcessRefund: '/sales/sale-cancellation-batch-refund',
  retriveExchangeBillPDF: '/sales-exchange/exchangenote/downloadpdf',
  legacySalesCancellationCreation: '/sales/lagacy-sale-cancellation-create',
  aeonPaymentList: '/payments/aeon-payment-list',
  aeonBatchRelease: '/payments/aeon-payment-cooling-off-release',
  eppPaymentList: '/payments/epp-payment-list',
  dailySalesReport: '/sale-daily-report',
  submitEppApproval: '/payments/update-epp-moto-approve-code',
  submitAeonAgreementNumber: '/payments/update-aeon-agreement-number',
  downloadPreOrderNote: '/download-preorder-note',
  batchCancelPayment: '/payments/payment-batch-cancel',
  convertEppMotoSales: '/payments/epp-moto-sale-convert',
  downloadAmpInvoice: '/download-auto-maintenance-invoice',
  enrollmentTypeByCountry: '/enrollment-types/',
  enrollmentProductKittingSearch: '/search/product-kitting/enrollment',
  submitBackOfficeEnrollment: '/enrollment/backoffice',
  getEnrollmentRankList: '/enrollment-ranks-list',
  getEnrollmentSalesTempData: '/enrollment-backoffice-temp-data/',
  updateAeonAgentCode: '/payments/update-aeon-agent-code',
  rentalSalesPreScreeningStatusUpdate: '/sales/rental-pre-screen-status-update',
  rentalSalesCredibilityStatusUpdate: '/sales/rental-credibility-status-update',
  rentalSalesConvertSales: '/sales/rental-credibility-release',
  rentalSalesRMSSalesNumberUpdate: '/sales/rental-ek-smart-number-update',
  paymentQRCode: '/qrcode/payment/',
  salesTransfer: '/sale/transfer',
  salesTransferListing: '/sale/transfer-list',
  svMonthAmendmentListing: '/sales/sv-month-amendment-list',
  svMonthAmendmentDetails: '/sales/sv-month-amendment/',
  svMonthAmendmentCreation: '/sales/sv-month-amendment',
  svTransferByProduct: '/sales/sv-transfer',
  svTransferByProductItems: '/sales/sv-transfer/product-kitting-list',
  expressEnrollment: '/enrollment',
  recordList: '/sales-list-e',
  recordDetail: '/e-sales-details',
  recordSalesRelease: '/e-sales-release',
  recordSalesCancellation: '/e-sales-cancellation',
  createECommerceRecord: '/sales/createECommerce',
}
